import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import LoaderModal from './LoaderModal';

const Wrapper = styled.div`
  margin-top: 90%;
`;

export const LoadingSpinner: FunctionComponent<{ label: string }> = ({
  label,
}) => (
  <Wrapper>
    <LoaderModal isOpen label={label} />
  </Wrapper>
);

export default LoadingSpinner;
